export enum SmsSetupActionType {
    BookingAppointment = "BOOKING_APPOINTMENT",
    CancelAppointment = "CANCEL_APPOINTMENT",
    ReminderAppointment = "REMINDER_APPOINTMENT",
    RadiologyResults = 'RADIOLOGY_RESULTS',
    SendInvoiceCopy = "SEND_INVOICE_COPY"
}
